import { FormattedMessage } from 'react-intl'
import { Box, styled } from '@mui/material'
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader } from '@carto/meridian-ds/components'
import { NOTIFICATION_DURATION_IN_MS } from '@carto/meridian-ds/theme'
import { useAppDispatch } from 'app/state'
import { useSFConnectCompleteTasksMutation, useSFConnectTasksQuery } from '../hooks/useSFConnectTasksQueries'
import { AlertSeverity, Notification, showNotification } from 'features/notifications/state/notificationSlice'
import useMobileBuilder from 'features/builder/ui/useMobileBuilder'
import PartnerConnectDialogContent from './PartnerConnectDialogContent'

const Content = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.spacing(0.5)
}))

const taskCompleteErrorNotification = (error: string): Notification => ({
  msg: error,
  formatted: false,
  type: AlertSeverity.Error,
  timeout: NOTIFICATION_DURATION_IN_MS * 2,
  closeable: true
})

function PartnerConnectDialog() {
  const dispatch = useAppDispatch()
  const isMobile = useMobileBuilder()
  const { isSFUserOnboarding, isOpen } = useSFConnectTasksQuery()

  const onError = (error) => {
    const notification = taskCompleteErrorNotification(error.message)
    dispatch(showNotification(notification))
  }

  const { mutateAsync: completeSFConnectTasks, isLoading } = useSFConnectCompleteTasksMutation(onError)

  const handleClose = () => {
    completeSFConnectTasks('welcome_dialog')
  }

  if (!isSFUserOnboarding || !isOpen) {
    return null
  }

  return (
    <Dialog
      aria-label="sf-connect-tasks-dialog"
      fullScreen={isMobile}
      scroll={isMobile ? 'paper' : 'body'}
      open={isOpen}
      onClose={handleClose}
      size="large"
      height="auto"
    >
      <DialogHeader title={<FormattedMessage id={'account.sfConnectDialog.title'} />} onClose={handleClose} />
      <DialogContent>
        <Content>
          <PartnerConnectDialogContent />
        </Content>
      </DialogContent>
      <DialogFooter>
        <Button onClick={handleClose} aria-label="sf-connect-tasks-dialog-done" loading={isLoading} color="primary">
          <FormattedMessage id="common.button.done" />
        </Button>
      </DialogFooter>
    </Dialog>
  )
}

export default PartnerConnectDialog
